import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next';
import Banner from '../components/Strategy/Banner';
import MissionVision from '../components/Strategy/MissionVision';
import Download from "../components/Home/Download";
import OurValues from '../components/Strategy/OurValues';
import { Pillers } from '../components/Strategy/Pillers';
import Goals from '../components/Strategy/Goals';
import OurSustainability from '../components/Home/OurSustainability';


function Strategy() {
  const { t } = useTranslation();

  const bannerData = {
    headline1: t("bannerStrategy.headLine1"),
    headline2: t("bannerStrategy.headLine2-1"),
    description: t("bannerStrategy.description"),
    img: '/imgs/strategy/strategy-banner2.png'
  }

  return (
    <div>
      <Helmet>
				<title>{t("head.strategy")}</title>
			</Helmet>
      <Banner bannerData={bannerData} strategyPage/>
      <MissionVision strategyPage/>
      {/* <OurSustainability /> */}
      <OurValues />
      <Pillers />
      <Goals />
      {/* <Download />  */}
    </div>
  )
}

export default Strategy